import Service from '@ember/service';
import posthog from 'posthog-js';
import config from 'walden-fast/config/environment';

export default class PostHogService extends Service {
  private initialized = false;
  private enabled = config.postHog.isEnabled;
  private apiUrl = config.postHog.apiUrl;
  private apiKey = config.postHog.apiKey;

  start(): void {
    if (!this.enabled) {
      return;
    }

    if (!this.initialized && config.postHog.apiUrl) {
      posthog.init(this.apiKey, {
        api_host: this.apiUrl,
        person_profiles: 'identified_only', // or 'always' to create profiles for anonymous users as well
      });

      this.initialized = true;
    } else {
      console.warn('[PostHog] Missing API data or already initialized.');
    }
  }

  sendCustomEvent(name: string, data: object) {
    posthog.capture(name, data);
  }
}

// Don't remove this declaration: this is what enables TypeScript to resolve
// this service using `Owner.lookup('service:chat')`, as well
// as to check when you pass the service name as an argument to the decorator,
// like `@service('chat') declare altName: ChatService;`.
declare module '@ember/service' {
  interface Registry {
    posthog: PostHogService;
  }
}
